import { render, staticRenderFns } from "./StateInspector.vue?vue&type=template&id=47f4d528&"
import script from "./StateInspector.vue?vue&type=script&lang=js&"
export * from "./StateInspector.vue?vue&type=script&lang=js&"
import style0 from "./StateInspector.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f4d528')) {
      api.createRecord('47f4d528', component.options)
    } else {
      api.reload('47f4d528', component.options)
    }
    module.hot.accept("./StateInspector.vue?vue&type=template&id=47f4d528&", function () {
      api.rerender('47f4d528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/components/StateInspector.vue"
export default component.exports